export default {
  // The filter above a catalogue's table: records and packets together, or one of the two. The records
  // are named like the catalogue ("Materials"), from nav.*.overview.
  kind_filter: {
    label: "Show",
    all: "All",
    packets: "Packets",
  },
  overview: {
    // The list of all packets (PacketOverview), reached through the command palette only.
    title: "Packets",
    subtitle: "All packets of materials, machines and additional efforts in one place.",
    search: {
      placeholder: "e.g. name",
    },
    // The line under the heading for somebody who may read a catalogue's packets but not the catalogue.
    subtitle_material: "Packets bundle several materials that a project or a customer takes over in one step.",
    subtitle_machine: "Packets bundle several machines that a project or a customer takes over in one step.",
    subtitle_additional_effort:
      "Packets bundle several additional efforts that a project or a customer takes over in one step.",
    actions: {
      create_new: "Create new Packet",
    },
    // Under the name of a packet row in a catalogue's table.
    row_caption: "Packet · {count} entry | Packet · {count} entries",
    // Under the name of a row in the list of all packets: the packet's kind.
    kind: {
      MATERIAL: "Material packet",
      MACHINE: "Machine packet",
      ADDITIONAL_EFFORT: "Additional effort packet",
    },
    table: {
      headers: {
        name: "Name",
        catalog: "Catalogue",
        amount: "Count",
      },
    },
  },
  detail: {
    title: "Packet Details",
    tabs: {
      general: "Master data",
      activity: "Activity",
    },
    actions: {
      update: "Save",
      delete: {
        modal: {
          title: "Delete Packet",
          text: "Are you sure you want to delete this packet?",
        },
        delete: "Delete",
      },
    },
    form: {
      name: "Name",
      // Stands in for the list while the packet is empty. It cannot be saved without a position, so
      // the placeholder says what to do about it.
      items_empty: "No positions yet. Search above for a record to put into the packet.",
      // Replaces items_empty once Speichern has been pressed: the position is then actually missing.
      items_required: "A packet needs at least one position.",
      // Column heads of the positions table. Unit and purchase price appear once a position carries
      // them (FrontendPacketTypeReferenceResponse) — on all three kinds of packet.
      table: {
        entry: "Entry",
        unit: "Billing unit",
        purchase_price: "Purchase price",
        no_price: "Not set",
      },
      additional_effort: {
        add: "Add additional effort",
        subheader: "Additional Efforts",
      },
      machine: {
        add: "Add machine",
        subheader: "Machines",
      },
      material: {
        add: "Add material",
        subheader: "Materials",
      },
    },
  },
  create: {
    additional_effort: {
      title: "Create Packet",
      subtitle: "Create a new Packet with additional efforts.",
    },
    machine: {
      title: "Create Packet",
      subtitle: "Create a new Packet with machines.",
    },
    material: {
      title: "Create Packet",
      subtitle: "Create a new Packet with materials.",
    },
  },
}
